// dateValue — общие преобразования между Date и ISO-строками для полей дат (MUI X).
// Единая точка: DatePickerField / DateTimePickerField / DateTimeField (V15-a).

/** Преобразует Date в ISO Instant строку (null/невалидная дата → null); для Instant-полей контрактов BE (TIMESTAMPTZ).
 *  Невалидная дата — промежуточный ввод MUI X-полей (поЧастичный ввод даты) → трактуется как «не выбрано», не крашится (дата.toISOString() кидает RangeError). */
export function toIsoInstant(d: Date | null): string | null {
  if (!d) return null;
  return Number.isNaN(d.getTime()) ? null : d.toISOString();
}

/** Преобразует Date в строку yyyy-MM-dd (локальная дата; null → null); для RHF LocalDate-полей
 *  (DatePickerField — deals/tasks/leads). Отличие от toIsoInstant — намеренное (контракты BE).
 *  Невалидная дата (например, «31.02.2026» — несуществующий день от MUI X) → null:
 *  иначе 'NaN-NaN-NaN' и RangeError в потребителях (F-1 pintest). */
export function toIsoDate(d: Date | null): string | null {
  if (!d) return null;
  if (Number.isNaN(d.getTime())) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Преобразует значение поля (yyyy-MM-dd / ISO Instant / Date) в Date; невалидное → null. */
export function parseFieldValue(value: unknown): Date | null {
  if (!value) return null;
  if (value instanceof Date) return value;
  const s = String(value);
  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}
